<template>
    <div class="dropsClassBox" style="width:100%;">
        <el-dialog
            :visible.sync="dialogYouXunDrops"
            width="60%"
            title="系统提示"
            :close-on-click-modal="false"
            :show-close="false"
            :close-on-press-escape="false"
            class=""
            center
            :before-close="handleClose"
            >
            <p class="dropsClassBox-tip">{{isDiaoXian? '系统监测到您的优巡监控掉线，请及时登录':''}}</p>
            <div class="youxunLoadin">
                <div class="info-app">
                    <p class="zhu-ji">主机位登录状态</p>
                    <p class="fu-ji">副机位登录状态</p>
                    <el-button class="exesy" :type="exeLogin? 'success':'info'" :icon="exeLogin? 'el-icon-check':'el-icon-close'" size="mini" style="cursor: auto;">{{exeLogin? '已登录':'未登录'}}</el-button>
                    <el-button class="appsy" :type="appLogin? 'success':'info'" :icon="appLogin? 'el-icon-check':'el-icon-close'" size="mini" style="cursor: auto;">{{appLogin? '已登录':'未登录'}}</el-button>
                </div>
                <div class="info-exe">
                    <span>准考证号：<b style="color:red">{{$route.query.ticketNum}}</b></span>
                    <span>考试ID号：<b style="color:red">{{$route.query.youXunExamNum}}</b></span>
                </div>
                <div class="waSkip-c-qr" ref="qrCodeUrlimg" id="qrCodeUrlId"></div>
            </div>
            <div class="info-refresh">
                <el-button class="updateAxios" size="mini" @click="reloadOnline" :style="{background:(timeOut<10? '#8ba1c1':'')}"> {{timeOut<10? `( ${timeOut} )`:'刷新'}} </el-button>
                <p>登录优巡后点击刷新查询登录状态，请登录后进行考试</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="closeBtu" class="closeBtu"> 返 回 </el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import utils from '../../lib/util'
import QRCode from 'qrcodejs2'
export default {
    name:'youXunDrops',
    props: {
        appLogin: Boolean,
        exeLogin: Boolean,
    },
    data() {
        return {
            dialogYouXunDrops:false,
            timeOut:10,
            isDiaoXian:false,
        }
    },
    watch:{},
    beforeDestroy() {
        this.threeTime && window.clearInterval(this.threeTime)
    },
    methods:{
        open(isDiaoXian=false){
            let that = this;
            // that.appLogin = data.second,
            // that.exeLogin = data.first
            that.isDiaoXian = isDiaoXian
            that.dialogYouXunDrops = true
            that.$nextTick(()=>{
                that.creatQrCode()
            })
        },
        handleClose(done){
            done();
        },
        reloadOnline(){
            let that = this
            if(that.timeOut<10) {
                that.$message.info('点击频率过快，请稍后再试！');
                return
            }
            that.getLoginStatus()
            that.timeOut -= 1
            that.timers = setInterval(() => {
                that.timeOut--;
                if(that.timeOut<=0){
                    clearInterval(that.timers)
                    that.timeOut = 10
                }
            }, 1000);
        },
        getLoginStatus(){
            this.$emit('getLoginStatus')
        },
        closeBtu(){
            this.dialogYouXunDrops = false
        },
        creatQrCode() {
            let that = this
            document.getElementById("qrCodeUrlId").innerHTML = "";
            let json = {
                "examNum": that.$route.query.youXunExamNum,
                "personNum": that.$route.query.ticketNum,
            }
            var qrcode = new QRCode(that.$refs.qrCodeUrlimg, {
                text: JSON.stringify(json), // 需要转换为二维码的内容
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.H
            })
        },
    }
}
</script>
<style scoped lang="less">
    .dropsClassBox{
        width: 100%;
        height: 100%;
    }
    .dropsClassBox-tip{
        font-size: 18px;
        font-weight: 500;
        color: #000;
        width: 100%;
        padding: 0 0 20px 0;
        text-align: center;
    }
    .youxunLoadin{
        width: 100%;
        height: 90px;
        margin: 10px 0;
        position: relative;
        .info-app{
            position: absolute;
            left: 0;
            bottom: 0;
            width: 43%;
            height: 100%;
            font-size: 18.5px;
            font-weight: bold;
            border-right: 1px solid #B2B2B2;
            .zhu-ji{
                position: absolute;
                left: 18%;
                top: 0px;
            }
            .fu-ji{
                position: absolute;
                left: 18%;
                bottom: 0%;
            }
            .exesy{
                position: absolute;
                left: 63%;
                top: 0%;
            }
            .appsy{
                display: inline-block;
                margin: 0 auto;
                position: absolute;
                left: 63%;
                bottom: 0%;
            }
        }
        .info-exe{
            position: absolute;
            top: 0;
            left: 41%;
            bottom: 0;
            width: 39%;
            height: 100%;
            font-size: 18.5px;
            font-weight: bold;
            position: relative;
            span:nth-child(1){
                position: absolute;
                left: 20%;
                top: 0;
                color: red;
            }
            span:nth-child(2){
                position: absolute;
                left: 20%;
                bottom: 0%;
                color: red;
            }
        }
        .waSkip-c-qr{
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            width: 20%;
            height: 110%;
        }
    }
     .info-refresh{
        width: 100%;
        height: 70px;
        position: relative;
        .updateAxios{
            position: absolute;
            left: 10%;
            background-color: #6AAEF8;
            border: none;
            font-size: 15px;
            width: 74px;
            height: 30px;
            line-height: 16px;
            color: #fff;
        }
        p{
            position: absolute;
            top: 40px;
            width: 100%;
            text-align: center;
        }
    }
    .youxunLoadin::after{
        height: 0;
        content: '';
        display: block;
        overflow: hidden;
        clear: both;
    }
</style>
<style>
    .dropsClassBox .el-dialog{
        min-width: 800px;
        max-width: 910px;
    }
    .youxunLoadin .waSkip-c-qr canvas,
    .youxunLoadin .waSkip-c-qr img{
        max-width: 100%;
        max-height: 100%;
        background-color: #fff;
        box-sizing: border-box;
        padding: 6px;
        border: 3px solid #000;
        overflow: hidden;
    }
</style>


// WEBPACK FOOTER //
// src/components/exam2/youXunDrops.vue